














































import { Component, Vue, Prop } from 'vue-property-decorator';
import employeesRepository from '@/modules/employees/employeesRepository';
import Card from '@/components/default/Card.vue';
import Datagrid from '@/components/default/Datagrid.vue';
import { DxSwitch } from 'devextreme-vue/switch';

import notificationService from '@/services/notificationService';
import { SecurityConfig } from '@/installationConfig';
import { UpdateEmployeeCommand, EmployeesClient } from '@/data/web-api-client';

@Component({
  components: {
    Card,
    Datagrid,
    DxSwitch
  },
})
export default class EmployeeDetails extends Vue {
  @Prop({required: true})
  private id!: string;

  private loading: boolean = false;
  private employee: any = null;
  private currentUser: any | null = null;
  private employeesClient = new EmployeesClient(undefined, this.$axios);

  private async mounted() {
    await this.loadData();
  }

  async toggleCanToggleProjectsOnHold(e: any) {
    const update = new UpdateEmployeeCommand({
      id: this.id,
      canToggleProjectsOnHold: this.employee.canToggleProjectsOnHold
    });

    try {
      await this.employeesClient.updateEmployee(update);
    } catch (err) {
      notificationService.showAxiosError(err);
    }
  }

  private async loadData() {
    try {
      this.loading = true;
      this.employee = (await employeesRepository.getSingle(this.id)).data;
      this.currentUser = this.$store.getters.currentUser;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }

  get title() {
    if (this.employee && this.employee.displayName) {
      return this.employee.displayName;
    }

    return 'Medewerker laden...';
  }

  get currentUserIsAdmin() {
    return !!this.currentUser.idTokenClaims?.groups?.find((g: any) => g == SecurityConfig.administratorGroup);
  }
}
